import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import mechaUnitPageStore from './store';
import cx from 'classnames';
import { MECHA_INFO } from './config';
// import AgeAppropriateTips from '@src/components/age-appropriate-tips';

import BaseSwiper from '@src/components/swiper/base-swiper';
const styles = require('./index.less');

const mechaUnitPage = ({ store }) => {
  store.use();
   const handleSlideClick = e => {
    const id = e.target.getAttribute('data-mecha-id');
    if (!id) {
      return;
    }
    store.gounit(id);
  };
  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div className={styles.mechaUnitSwiper} onClick={handleSlideClick}>
        {store.mechaList.length ? (
          <BaseSwiper store={store.mechaUnitSwiper}>
            {MECHA_INFO.map(item => {
              const { kv } = store.mechaList.find(i => i.mecha_id === item.id) || {};
              return (
                <div className={styles.slideItem} key={item.id}>
                  {React.createElement(item.component, {store, isActive: true, mechaId: item.id, kvImg: kv })}
                </div>
              );
            })}
          </BaseSwiper>
        ) : null}
        <div className={styles.prev} onClick={store.mechaUnitSwiper.goPrev}></div>
        <div className={cx(styles.indicatorBox, 'indicatorBoxs')}>
          <div className={styles.swiper_tab}>
            {MECHA_INFO?.map((tab, index) => (
              <div key={index} className={cx(styles.tabItem, index === store.tabIndex && styles.tabActive)} onClick={() => store.changeTab(index)} />
            ))}
          </div>
        </div>
        <div className={styles.next} onClick={store.mechaUnitSwiper.goNext}></div>
      </div>
    </div>
  );
};

export default wrapStore(mechaUnitPage, mechaUnitPageStore);
